import {Pipe, PipeTransform} from '@angular/core';
import {DATE_FORMAT} from '@common/const/form.constants';

import * as dayjs from 'dayjs';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

@Pipe({
  standalone: true,
  name: 'tmwDate',
})
export default class TmwDatePipe implements PipeTransform {
  transform(day: any): string {
    if (!day) return '-';
    
    // Si c'est une chaîne au format DD/MM/YYYY, parser avec le format explicite
    if (typeof day === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(day)) {
      return dayjs(day, DATE_FORMAT).format(DATE_FORMAT);
    }
    
    // Sinon, laisser dayjs parser automatiquement
    return dayjs(day).format(DATE_FORMAT);
  }
}
